const constants = {
  INIT_NEAR: "INIT_NEAR",
  WALLET: "WALLET",
  LOGIN: "LOGIN",
  ADD_MEME: "ADD_MEME",
  GET_MEME_TOKEN_LIST: "GET_MEME_TOKEN_LIST",
  TITLE: "TITLE_CREATE_BUCKET",
  LOADING: "LOADING",
};

export default constants;
